import { EmptySet } from 'lib/array/arrayUtils'
import React, { useRef, useState } from 'react'
import { parsePickedMonth, PickedMonth } from './MonthPicker'
import MonthPickerSelectInput from './MonthPickerSelectInput'
import moment from 'moment'

export function parseTailorMadeTourDatesValue(value: string): Tours.TailorMadeTourRequest['travelDates'] {
  return value.split(',').map(parsePickedMonth)
}

function determineBoundaries(): { min: PickedMonth; max: PickedMonth } {
  const min = moment().add(3, 'months').format('YYYY-MM') as PickedMonth
  const max = moment().add(2, 'years').set('month', 11).format('YYYY-MM') as PickedMonth
  return { min, max }
}

function parseDefaultValue(defaultValue?: Tours.TailorMadeTourRequest['travelDates']): Set<PickedMonth> {
  if (!defaultValue) return EmptySet
  return new Set<PickedMonth>(defaultValue.map<PickedMonth>(v => `${v.year}-${v.month}`))
}

interface Props {
  name: string
  defaultValue?: Tours.TailorMadeTourRequest['travelDates']
}

function TailorMadeTourDatesInput({ name, defaultValue }: Props) {
  const boundariesRef = useRef(determineBoundaries())
  const [value, setValue] = useState<Set<PickedMonth>>(parseDefaultValue(defaultValue))

  return <MonthPickerSelectInput
    value={value}
    name={name}
    label="When are you looking to travel?"
    placeholder="Select year and month"
    required
    min={boundariesRef.current.min}
    max={boundariesRef.current.max}
    onChange={setValue}
  />
}

export default TailorMadeTourDatesInput
